import { FC } from 'react';

export type TabItem = {
  value: string;
  label: string;
};

interface TabsProps {
  items: TabItem[];
  active: string;
  onChange: (value: string) => void;
  className?: string;
}

const Tabs: FC<TabsProps> = ({ items, active, onChange, className = '' }) => (
  <div
    role="tablist"
    className={`flex flex-wrap gap-2 border-b-2 border-[rgba(0,0,0,.12)] ${className}`}
  >
    {items.map((item) => {
      const isActive = item.value === active;
      return (
        <button
          key={item.value}
          type="button"
          role="tab"
          aria-selected={isActive}
          onClick={() => onChange(item.value)}
          className={`px-4 py-2.5 text-[15px] font-medium -mb-px border-b-2 transition-colors ${
            isActive
              ? 'border-[#333] text-[#333]'
              : 'border-transparent text-[rgba(0,0,0,.55)] hover:text-[#333]'
          }`}
        >
          {item.label}
        </button>
      );
    })}
  </div>
);

export default Tabs;
